var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconUnderlinedU48Line(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "current",
    height: "current",
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M37 34.4001H11V37.8001H37V34.4001Z",
    fill: "current"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M24 30.9001C18.6 30.9001 14.2 26.5001 14.2 21.1001V10.1001H17.8V21.1001C17.8 24.5201 20.58 27.3001 24 27.3001C27.42 27.3001 30.2 24.5201 30.2 21.1001V10.1001H33.8V21.1001C33.8 26.5001 29.4 30.9001 24 30.9001Z",
    fill: "current"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconUnderlinedU48Line);
export default __webpack_public_path__ + "static/media/icon_underlined_u_48_line.51968d7a39df5dce019863a6c1f301e3.svg";
export { ForwardRef as ReactComponent };